import { CONNECTION_STATE_DECOMMISSIONED } from './constants';

type ConnectionLike = { ready?: boolean; state?: string } | null | undefined;

/**
 * True when `connections` is non-empty and every entry has state DECOMMISSIONED.
 */
export function allConnectionsDecommissioned(
  connections: Record<string, ConnectionLike> | null | undefined,
): boolean {
  if (!connections || typeof connections !== 'object') {
    return false;
  }

  const entries = Object.values(connections);
  if (entries.length === 0) {
    return false;
  }

  return entries.every((connection) => connection?.state === CONNECTION_STATE_DECOMMISSIONED);
}
